<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span *ngIf="data == null" class="title dialog-title">Cadastrar Usuários</span>
            <span *ngIf="data != null" class="title dialog-title">Atualizar Usuário</span>
            <button mat-icon-button (click)="onNoClick()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>

        <mat-toolbar-row class="toolbar-bottom py-16" fxLayout="column" fxLayoutAlign="center center">
            
            <img 
                [src]="model.url_avatar" 
                class="avatar contact-avatar huge m-0"
                [alt]="model.name"/>

            <div class="contact-name mt-8">{{model.name}}</div>
        </mat-toolbar-row>
    </mat-toolbar>

    <div  mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <div fxLayout="row wrap" *ngIf="(user.role_id == 2 ||user.role_id == 7) ">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" >
                    <mat-label>Pefil</mat-label>
                    <mat-icon matSuffix class="secondary-text">person</mat-icon>
                    <mat-select 
                        placeholder="Perfil" 
                        [(value)]="model.role_id"
                        [formControl]="role_id" 
                        style="width: 100%"
                        required >
                        <mat-option *ngFor="let role of listRoles"
                            [value]="role.id">{{role.name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="role_id.invalid">{{getErrorRoleMessage()}}</mat-error>
                </mat-form-field>
            </div>
        </div>
    
        <div fxLayout="row wrap" *ngIf="(user.role_id == 2 ||user.role_id == 7)">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" >
                    <mat-label>Escritório Padrão</mat-label>
                    <mat-icon matSuffix class="secondary-text">business</mat-icon>
                    <mat-select 
                        placeholder="Escritório Padrão"                    
                        [formControl]="escritorio_id" 
                        style = "width: 100%"
                        required>
                        <mat-option *ngFor="let escritorio of listEscritorios"
                            [value]="escritorio.id">{{escritorio.nome_fantasia}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="escritorio_id.invalid">{{getErrorEscritorioMessage()}}</mat-error>
                </mat-form-field>
            </div>
        </div>
    
        <div fxLayout="row wrap" *ngIf="(user.role_id == 2 ||user.role_id == 7)">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" >
                    <mat-label>Escritório</mat-label>
                    <mat-icon matSuffix class="secondary-text">business</mat-icon>
                    <mat-select 
                        placeholder="Escritório"                    
                        [formControl]="escritorios" 
                        style = "width: 100%"
                        multiple>
                        <mat-option *ngFor="let escritorio of listEscritorios"
                            [value]="escritorio.id">{{escritorio.nome_fantasia}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="escritorio_id.invalid">{{getErrorEscritorioMessage()}}</mat-error>
                </mat-form-field>
            </div>
        </div>
    
        <div fxLayout="row wrap" *ngIf="(user.role_id == 2 ||user.role_id == 7)">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>Sócio</mat-label>
                    <mat-icon matSuffix class="secondary-text">business</mat-icon>
                    <mat-select 
                        placeholder="Sócio" 
                        [(value)]="model.tipo_usuario_id"
                        [formControl]="tipo_usuario_id" 
                        style="width: 100%">
                        <mat-option *ngFor="let tipoUsuario of listTipoUsuario"
                            [value]="tipoUsuario.id">{{tipoUsuario.nome}}</mat-option>
                    </mat-select>                
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>Código AAI</mat-label>
                    <mat-icon matSuffix class="secondary-text">contacts</mat-icon>
                    <input 
                        matInput 
                        placeholder="Código AAI" 
                        [formControl]="codigo_aai"                     
                        type="number" 
                        maxlength="255">                
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>Nome</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input 
                        matInput 
                        placeholder="Nome" 
                        [formControl]="name" 
                        required
                        maxlength="255">
                    <mat-error *ngIf="name.invalid">{{getErrorNameMessage()}}</mat-error>
                </mat-form-field>
            </div>
        </div>

        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>E-mail</mat-label>
                    <mat-icon matSuffix class="secondary-text">contact_mail</mat-icon>
                    <input 
                        matInput 
                        placeholder="E-mail" 
                        [formControl]="email"
                        required 
                        maxlength="255"
                    >
                    <mat-error *ngIf="email.invalid">{{getErrorEmailMessage()}}</mat-error>
                </mat-form-field>
            </div>
        </div>

        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>Data de Nascimento</mat-label>
                    <input 
                        matInput 
                        [matDatepicker]="picker" 
                        [formControl]="data_nascimento" 
                        name="data_nascimento" 
                        placeholder="Data de Nascimento"
                    >
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
       

        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>CPF</mat-label>
                    <mat-icon matSuffix class="secondary-text">description</mat-icon>
                    <input 
                        matInput 
                        placeholder="000.000.000-00" 
                        [formControl]="cpf"                         
                        maxlength="15"
                        mask="000.000.000-00"
                    >                    
                </mat-form-field>
            </div>
        </div>

        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>Telefone</mat-label>
                    <mat-icon matSuffix class="secondary-text">contact_phone</mat-icon>
                    <input 
                        matInput 
                        placeholder="Telefone" 
                        [formControl]="telefone"                         
                        maxlength="15"
                        mask="(00) 00000-0000"
                    >                    
                </mat-form-field>
            </div>
        </div>
    
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>Senha</mat-label>
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <input 
                        matInput 
                        type="password" 
                        placeholder="Senha"
                        [formControl]="password" 
                        required 
                        maxlength="255"
                        minlength="6">
                    <mat-error *ngIf="password.errors?.['maxlength'] &&
                        password.touched" class="text-danger support-text">Você deve
                        incluir até 255 caractéres.</mat-error>
                    <mat-error *ngIf="password.errors?.['minlength'] &&
                        password.touched" class="text-danger support-text">Você deve
                        incluir no mínimo 6 caractéres.</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>Confirmar Senha</mat-label>
                    <mat-icon matSuffix class="secondary-text">check_circle</mat-icon>
                    <input 
                        matInput 
                        type="password" 
                        placeholder="Confirmar Senha"
                        [formControl]="confirm_password" 
                        required 
                        maxlength="255"
                        minlength="6">
                    <mat-error *ngIf="password.value != confirm_password.value">A
                        senha deve ser igual a confirmação de senha.</mat-error>
                    <mat-error *ngIf="confirm_password.errors?.['maxlength'] &&
                        confirm_password.touched" class="text-danger support-text">Você
                        deve incluir até 255 caractéres.</mat-error>
                    <mat-error *ngIf="confirm_password.errors?.['minlength'] &&
                        confirm_password.touched" class="text-danger support-text">Você
                        deve incluir no mínimo 6 caractéres.</mat-error>
                </mat-form-field>
            </div>
        </div>
    
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button 
            mat-raised-button
            tabindex="2" 
            (click)="onNoClick()"
            style="margin-right: 10px;"
        >
            <mat-icon aria-label="Excluir Boleta">exit_to_app</mat-icon>
            Cancelar
        </button>

        <button 
            mat-raised-button
            color="warn"
            [disabled]="isInvalidForm()" 
            (click)="delete(model.id)"
            tabindex="-1"
            style="margin-right: 10px;"
            *ngIf="(user.role_id == 2 ||user.role_id == 7)"
        >
            <mat-icon aria-label="Excluir Boleta">delete</mat-icon>
            Excluir
        </button>

        <button 
            mat-raised-button 
            class="green"            
            [disabled]="isInvalidForm()" 
            (click)="salvar()"
            tabindex="-1"
        >
            <mat-icon aria-label="Excluir Boleta">save</mat-icon>
            Salvar
        </button>
    </div>

</div>


